import type { SVGProps } from 'react'
const SvgSyCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m8.6 20.4-8-8 2-2 6 6L21.4 3.6l2 2z" />
	</svg>
)
export default SvgSyCheck
